import axios from "axios";
import React from "react";
import { Button, Card, Form, Modal } from "react-bootstrap";
import { MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import DropZone from "../../components/DropZone";
import LoaderButton from "../../components/LoaderButton";
import { Constants } from "../../libs/Constants";
import { update } from "../../libs/dbFunctions";
import { placeEvent } from "../../libs/eventsLib";
import useEmployeeContext from "./contexts/useEmployeeContext";
import { isUnAvailableRegion } from "./SetupComplete";
import "./UploadPayStubButton.scss";
const UploadPayStubButton = () => {
  const { refreshEmployee, employee } = useEmployeeContext();
  const [open, setOpen] = React.useState(false);
  const [currentlyEnrolled, setCurrentlyEnrolled] = React.useState(null);
  const [files, setFiles] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = async () => {
    // call api to upload
    setLoading(true);
    let saveFields = {
      id: employee.id,
      enrollmentStatus: true,
      payStubFile: files[0].name,
      fileType: files[0].type,
    };
    //update the userObj with salary and flags
    try {
      let response = await update(
        Constants.dbTypes.USER,
        saveFields,
        employee.companyId
      );
      if (response && response.url && response.key) {
        await uploadFile(response, files[0]);
        await placeEvent(
          Constants.EVENT_TYPES.PAYSTUB_UPLOADED,
          employee.email,
          {
            enrollmentStatus: saveFields.enrollmentStatus,
            payStubFile: response.key,
            fileType: saveFields.fileType,
          }
        );
      }
      refreshEmployee();
      setOpen(false);
    } catch (e) {
      if (e.response && e.response.data && e.response.data.error) {
        toast.error(e.response.data.error);
      } else {
        toast.error(e);
      }
    }
  };

  const uploadFile = async (response, file) => {
    // Upload file to s3
    const options = {
      params: {
        Key: response.key,
        ContentType: file.type,
      },
      headers: {
        "Content-Type": file.type,
      },
    };
    try {
      await axios.put(response.url, file, options);
    } catch (err) {
      console.log(err);
      toast.error("Unable to upload file. Please contract your administrator");
    }
  };
  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        disabled={isUnAvailableRegion(employee)}
      >
        Upload
      </Button>
      <Modal
        show={open}
        onHide={() => setOpen(false)}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="contribution-modal font-secondary"
        backdrop="static"
      >
        <Modal.Header className="px-4 border-0" closeButton>
          <Modal.Title>
            <div className="fw-bold">Pay Stub</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="ps-2">
            <div className="font-size-3">
              Are you currently enrolled in an ESPP?
            </div>
            <div className="mt-1">
              <Form.Check type="radio" id="currentlyEnrolled">
                <Form.Check.Input
                  type="radio"
                  onChange={() => setCurrentlyEnrolled(true)}
                  checked={currentlyEnrolled != null && currentlyEnrolled}
                />
                <Form.Check.Label>
                  <div className="font-size-3">Yes</div>
                </Form.Check.Label>
              </Form.Check>
              <Form.Check type="radio" id="currentlyEnrolled">
                <Form.Check.Input
                  type="radio"
                  onChange={() => setCurrentlyEnrolled(false)}
                  checked={currentlyEnrolled != null && !currentlyEnrolled}
                />
                <Form.Check.Label>
                  <div className="font-size-3">No</div>
                </Form.Check.Label>
              </Form.Check>
            </div>
            {currentlyEnrolled != null && !currentlyEnrolled && (
              <div className="text-danger font-size-4">
                Please enroll in your company's ESPP before continuing this step
              </div>
            )}
            {currentlyEnrolled && (
              <>
                <div className="d-flex justify-content-center drag-drop-card-pay-stub">
                  <Card>
                    {!files && (
                      <DropZone
                        onSubmit={(selectedFiles) => {
                          setFiles(selectedFiles);
                        }}
                        errorMessage={"Drop to Upload Pay Stub"}
                        id="company"
                        uploading={false}
                      />
                    )}
                    {files?.length > 0 && (
                      <div className="d-flex justify-content-center align-items-center h-100">
                        <div className="font-size-4">{files[0].name}</div>
                        <div className="ms-1">
                          <MdDelete
                            className="text-danger"
                            onClick={() => setFiles(null)}
                          />
                        </div>
                      </div>
                    )}
                  </Card>
                </div>
                <div className="font-size-3 mt-1 mb-1">
                  <div className="fw-bold">Should include:</div>
                  <div>- Company name (validation)</div>
                  <div>- Personal name and address (validation)</div>
                  <div>- Most recent pay period</div>
                  <div>
                    - Year to date salary (calculate/validate annual pay)
                  </div>
                  <div>-Deductions (401K/ESPP)</div>
                </div>
              </>
            )}
          </div>
          <LoaderButton
            isLoading={loading}
            block
            className="mt-3"
            onClick={() => {
              handleSubmit();
            }}
            disabled={!currentlyEnrolled || !files}
          >
            Submit
          </LoaderButton>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default UploadPayStubButton;
